import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { MEMORY_MAP_IMAGES } from '../../shared/memory-map-assets';
import styles from './MemoryPhotoV1.css';

const cx = classnames.bind(styles);

function MemoryPhotoV1({ imageId, className = '', radius = 'default' }) {
    return (
        <div className={cx('root', radius, className)}>
            <img
                src={MEMORY_MAP_IMAGES[imageId]}
                alt=''
                className={styles.image}
                decoding='async'
                width='1130'
                height='848'
            />
        </div>
    );
}

MemoryPhotoV1.propTypes = {
    imageId: PropTypes.string.isRequired,
    className: PropTypes.string,
    radius: PropTypes.oneOf(['default', 'large', 'small', 'none'])
};

export {
    MemoryPhotoV1
};
